import { render } from "./finance-service-party-card.vue?vue&type=template&id=c3323ce8"
import script from "./finance-service-party-card.vue?vue&type=script&lang=js"
export * from "./finance-service-party-card.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__